const AGENT = {
    'buyAgent': {
        url: "upms/buy/buyAgent",
        method: "POST"
    },

}

export default AGENT;
